import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { crm } from "@/lib/crm";
import { BatteryCharging, ShieldCheck, ArrowRight, Check } from "lucide-react";

const C = { green: "#00E5A0", cyan: "#00D4FF", gold: "#FFD700" };
function tone(soh) {
  if (soh >= 90) return { c: "#00E5A0", label: "Excellent" };
  if (soh >= 75) return { c: "#7CFC00", label: "Bon" };
  if (soh >= 60) return { c: "#FF8C00", label: "Attention" };
  return { c: "#FF2D2D", label: "Critique" };
}

// Pactly Battery Trust seal on the car detail page: if a certified battery
// diagnostic exists for this VIN, surface the SOH + a link to the passport.
export default function BatteryPassport({ car }) {
  const vin = String(car?.vin || car?.chassis || car?.chassis_number || "").trim();
  const [rep, setRep] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (vin.length !== 17) return;
    let alive = true;
    crm(`/battery/exists?vin=${encodeURIComponent(vin)}`)
      .then((r) => { if (alive && r?.exists) setRep(r); })
      .catch(() => {});
    return () => { alive = false; };
  }, [vin]);

  if (!rep) return null;
  const t = tone(rep.soh_percent);

  return (
    <div data-testid="car-battery-passport" className="mt-6 overflow-hidden rounded-2xl border"
      style={{ borderColor: `${C.green}55`, background: "linear-gradient(135deg, rgba(0,229,160,0.08), rgba(0,212,255,0.06))" }}>
      <div className="flex flex-wrap items-center justify-between gap-4 p-5">
        <div className="flex items-center gap-3">
          <span className="flex h-11 w-11 items-center justify-center rounded-xl"
            style={{ background: "linear-gradient(135deg,#00E5A0,#00D4FF)", boxShadow: `0 0 22px ${C.green}55` }}>
            <BatteryCharging size={22} className="text-[#0A1024]" />
          </span>
          <div>
            <div className="flex items-center gap-1.5 font-display text-sm font-extrabold" style={{ color: C.green }}>
              <ShieldCheck size={15} style={{ color: C.gold }} /> Passeport Batterie certifié Pactly
            </div>
            <div className="text-xs text-muted-foreground">Diagnostic vérifié · rapport #{rep.report_id}</div>
          </div>
        </div>
        <div className="flex items-center gap-4">
          <div className="text-right">
            <div className="font-mono text-2xl font-extrabold" style={{ color: t.c }}>{rep.soh_percent}%</div>
            <div className="text-[11px] font-bold uppercase tracking-wide" style={{ color: t.c }}>SOH · {t.label}</div>
          </div>
          <button data-testid="car-battery-view-btn" onClick={() => navigate(`/verify/${rep.report_id}`)}
            className="flex items-center gap-1.5 rounded-xl px-4 py-2.5 text-sm font-bold text-[#0A1024] transition hover:opacity-90"
            style={{ background: "linear-gradient(135deg,#00E5A0,#00D4FF)" }}>
            Voir le passeport <ArrowRight size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}
